<template>
	<div class="content flex flex-align-start">
		<div class="flex-1 mr40">
			<el-form ref="form" label-width="90px">
				<el-form-item label="学历类别：">
					<el-radio-group v-model="radio">
						<el-radio :label="index" v-for="(item,index) in types" :key="index">{{ item.text }}</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			
			<div style="margin-top: 10px;width: 600px;">
				<el-input placeholder="请输入内容" v-model="desc" class="input-with-select" @keyup.enter.native="search()">
				    <el-select v-model="active" slot="prepend" placeholder="请选择" style="width: 120px;">
						<el-option :label="item.text" :value="index" v-for="(item,index) in category" :key="index"></el-option>
				    </el-select>
				    <el-button slot="append" icon="el-icon-search" :loading="loading" @click="search()"></el-button>
				</el-input>
			</div>
			
			<div class="mt30" v-if="isReady">
				<!-- table -->
				<el-table :data="list" v-loading="isLoading" border style="width: 100%" :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#000000', fontSize: '16px' }">
				    <el-table-column :prop="'col' + index" :label="item" align="center" :width="item == '专业代码'?'120':''" v-for="(item,index) in tableHeader" :key="index"></el-table-column>
					
					<!-- 暂无数据 -->
					<template #empty>
						<el-empty description="暂无数据" :image-size="120"></el-empty>
					</template>
				</el-table>
				
				<!-- 分页 -->
				<div class="mt20" v-if="list.length">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="pageSizeArr" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
				</div>
			</div>
		</div>
		
		<!-- 宣传图 -->
		<div class="sticky" style="top: 200px;">
			<el-carousel class="border-radius-10" style="width: 360px;" trigger="click" :interval="5000" arrow="never" height="480px">
				<el-carousel-item v-for="(item,index) in swiper" :key="index">
					<el-image style="width: 360px;height: 480px;" :src="item.image" fit="cover"></el-image>
				</el-carousel-item>
			</el-carousel>
		</div>
	</div>
</template>

<script>
import { EventBus } from '@/main.js'
export default {
	name: 'CheckMajor',
	data(){
		return{
			types: [
				{ text: '专科', type: 'ZY_ZK' },
				{ text: '本科', type: 'ZY_BK' },
				{ text: '职业本科', type: 'ZY_ZYBK' },
				{ text: '硕士研究生', type: 'ZY_SSYJS' }
			],
			radio: 1,
			
			desc: '',
			active: 0,
			
			loading: false,  // 搜索按钮loading
			tableHeader: [],  // 表头
			list: []
		}
	},
	computed: {
		category(){
			return [
				{ text: '专业名称', key: 'nameLike' },
				{ text: '专业类', key: 'professionalLike' },
				{ text: this.radio == 0 || this.radio == 2 ? '专业大类' : '专业门类', key: 'majorLike' }
			]
		}
	},
	mounted(){
		EventBus.$emit('router-path', this.$route.path)
		this.getData()
	},
	watch: {
		radio(n){
			this.isReady = false
			this.list = []
			this.getData()
		}
	},
	methods: {
		search(){
			// if(!this.token) return EventBus.$emit('show-login', true)
			if(!this.desc) return this.$message({ message: '请输入' + this.category[this.active].text, type: 'warning' })
			this.loading = true
			this.isReady = false
			this.list = []
			
			this.getData()
		},
		
		handleSizeChange(val) {
			this.page_size = val
			this.isLoading = true
			this.getData()
		},
		handleCurrentChange(val) {
			this.page = val
			this.isLoading = true
			this.getData()
		},
		
		async getData(){
			let params = {
				pageNum: this.page,
				pageSize: this.page_size,
				type: this.types[this.radio].type
			}
			params[this.category[this.active].key] = this.desc
			this.$http.get('/api/webs/search/czy', { params })
			    .then(response => {
			        let res = response.data
			        this.loading = false
			        this.isLoading = false
			        this.isReady = true
			       
			        this.totalCount = res.total
			        this.tableHeader = res.data.header
			        this.list = res.list
			    })
			    .catch(error => {
			        console.error(error)
					this.loading = false
					this.isLoading = false
			    })
		}
	}
}
</script>

<style scoped>
.el-form-item{
	margin-bottom: 0 !important;
}
.el-input--suffix{
	width: 110px !important;
}
/* 隐藏单选框的圆圈 */
:deep(.el-radio__input) {
  display: none;
}
:deep(.el-radio__label) {
  padding-left: 0px;
}
/* 单选框之间的间距 */
:deep(.el-radio) {
  margin-right: 20px;
}
</style>